import { render, staticRenderFns } from "./shopIntegralDetail.vue?vue&type=template&id=6fedc17c&scoped=true"
import script from "./shopIntegralDetail.vue?vue&type=script&lang=js"
export * from "./shopIntegralDetail.vue?vue&type=script&lang=js"
import style0 from "./shopIntegralDetail.vue?vue&type=style&index=0&id=6fedc17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fedc17c",
  null
  
)

export default component.exports